import { logout } from "../store/actions/auth/index";

export function CodificaError(errorCode, errorMessage) {
  switch (errorCode) {
  case "401":
    logout();
    break;
  case "403":
    logout();
    break;
  default:
    return errorMessage;
  }
}
